// FinTrack — UI utilities (toast, loading, modals, particles, SVG icons)

// Centralized SVG icon map (Lucide-style, 24x24 viewBox)
// All values are static hardcoded SVG path data — no user input
const ICONS = {
  edit: '<path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/>',
  trash: '<path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>',
  download: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>',
  save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>',
  upload: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>',
  folder: '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>',
  file: '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><polyline points="14 2 14 8 20 8"/>',
  play: '<polygon points="6 3 20 12 6 21 6 3"/>',
  refresh: '<polyline points="1 4 1 10 7 10"/><polyline points="23 20 23 14 17 14"/><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4-4.64 4.36A9 9 0 0 1 3.51 15"/>',
  chart: '<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>',
  clock: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  calendar: '<rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  building: '<rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01"/>',
  users: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  bookmark: '<path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20l-8-5-8 5Z"/>',
  scroll: '<path d="M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4"/><path d="M19 17V5a2 2 0 0 0-2-2H4"/>',
  key: '<path d="m21 2-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.78 7.78 5.5 5.5 0 0 1 7.78-7.78Zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4"/>',
  sun: '<circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>',
  moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>',
  link: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>',
  pin: '<line x1="12" y1="17" x2="12" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
  check: '<polyline points="20 6 9 17 4 12"/>',
  construction: '<rect x="2" y="6" width="20" height="8" rx="1"/><path d="M17 14v7M7 14v7M17 3v3M7 3v3"/>',
  eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
  clipboard: '<rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>',
  fire: '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>',
  warning: '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
  x: '<path d="M18 6L6 18M6 6l12 12"/>',
  menu: '<line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="18" x2="20" y2="18"/>',
  lock: '<rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
  sort: '<path d="m3 16 4 4 4-4M7 20V4M21 8l-4-4-4 4M17 4v16"/>',
  'sort-asc': '<path d="m3 8 4-4 4 4M7 4v16"/>',
  'sort-desc': '<path d="m3 16 4 4 4-4M7 20V4"/>'
};

// Returns SVG markup string (for use in static HTML via build or template literals)
export function icon(name, size = 16) {
  const d = ICONS[name] || '';
  return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>';
}

// Returns SVG as DOM element using DOMParser (safe — input is from hardcoded ICONS map only)
export function svgIcon(name, size = 16) {
  const markup = icon(name, size);
  const doc = new DOMParser().parseFromString(markup, 'image/svg+xml');
  return doc.documentElement;
}

// ============================================================
// TOAST NOTIFICATION — stacking (max 3 visible, queue for rest)
// ============================================================
const toastQueue = [];
const toastActive = [];
const MAX_TOASTS = 3;

function createToastEl(m, t, undoFn) {
  const el = document.createElement('div');
  el.className = 'toast-item show ' + t;
  const span = document.createElement('span');
  span.textContent = m;
  el.appendChild(span);
  if (undoFn) {
    const btn = document.createElement('button');
    btn.textContent = 'Poništi';
    btn.style.cssText = 'margin-left:12px;background:rgba(255,255,255,.2);border:1px solid rgba(255,255,255,.3);color:inherit;padding:3px 10px;border-radius:4px;cursor:pointer;font-size:11px';
    btn.onclick = () => { undoFn(); removeToast(el); };
    el.appendChild(btn);
  }
  const closeBtn = document.createElement('button');
  closeBtn.textContent = '\u00D7';
  closeBtn.style.cssText = 'margin-left:8px;background:none;border:none;color:inherit;cursor:pointer;font-size:16px;padding:0 2px;opacity:.6';
  closeBtn.onclick = () => removeToast(el);
  el.appendChild(closeBtn);
  return el;
}

function removeToast(el) {
  el.classList.remove('show');
  const idx = toastActive.indexOf(el);
  if (idx >= 0) toastActive.splice(idx, 1);
  setTimeout(() => { el.remove(); repositionToasts(); processToastQueue(); }, 350);
  repositionToasts();
}

function repositionToasts() {
  let bottom = 28;
  toastActive.forEach(el => {
    el.style.bottom = bottom + 'px';
    bottom += el.offsetHeight + 10;
  });
}

function processToastQueue() {
  while (toastQueue.length > 0 && toastActive.length < MAX_TOASTS) {
    const { m, t, undoFn } = toastQueue.shift();
    showToastEl(m, t, undoFn);
  }
}

function showToastEl(m, t, undoFn) {
  const container = document.getElementById('toastContainer') || createToastContainer();
  const el = createToastEl(m, t, undoFn);
  container.appendChild(el);
  toastActive.push(el);
  requestAnimationFrame(() => repositionToasts());
  const timer = setTimeout(() => removeToast(el), undoFn ? 8000 : 5000);
  el._timer = timer;
}

function createToastContainer() {
  const c = document.createElement('div');
  c.id = 'toastContainer';
  c.style.cssText = 'position:fixed;bottom:0;right:28px;z-index:2000;pointer-events:none';
  document.body.appendChild(c);
  return c;
}

/**
 * Show toast notification with stacking support
 * @param {string} m - Message
 * @param {string} [t='suc'] - Type: 'suc', 'err', 'warn'
 * @param {Function} [undoFn] - Optional undo callback
 */
export function toast(m, t = 'suc', undoFn) {
  // Also update legacy toast element for backwards compat
  const legacyEl = document.getElementById('toast');
  if (legacyEl) { legacyEl.className = 'toast'; } // hide legacy

  if (toastActive.length >= MAX_TOASTS) {
    toastQueue.push({ m, t, undoFn });
    return;
  }
  showToastEl(m, t, undoFn);
}

export function showLoading() {
  document.getElementById('ftLoading')?.classList.add('active');
}

export function hideLoading() {
  document.getElementById('ftLoading')?.classList.remove('active');
}

export function clMdl(id) {
  document.getElementById(id).classList.remove('active');
}

// ============================================================
// REUSABLE EDIT MODAL — replaces all prompt() calls
// ============================================================
/**
 * Open reusable edit modal
 * @param {string} title - Modal title
 * @param {Array<{label:string, value:string|number, type?:string, key:string}>} fields
 * @param {Function} onSave - Callback with object of field values {key: value}
 */
export function openEditModal(title, fields, onSave) {
  const mdl = document.getElementById('mdlEdit');
  document.getElementById('meTitle').textContent = title;
  const body = document.getElementById('meBody');
  body.textContent = '';
  body.style.cssText = fields.length > 6 ? 'max-height:60vh;overflow-y:auto;padding-right:8px' : '';

  fields.forEach(f => {
    const fg = document.createElement('div');
    fg.className = 'afg';
    const lbl = document.createElement('label');
    lbl.textContent = f.label;
    const inp = document.createElement('input');
    inp.type = f.type || 'text';
    inp.className = 'ain';
    inp.value = f.value != null ? f.value : '';
    inp.dataset.key = f.key;
    if (f.step) inp.step = f.step;
    if (f.placeholder) inp.placeholder = f.placeholder;
    fg.appendChild(lbl);
    fg.appendChild(inp);
    body.appendChild(fg);
  });

  // Focus first input
  requestAnimationFrame(() => {
    const first = body.querySelector('input');
    if (first) { first.focus(); first.select(); }
  });

  // Save handler
  const saveBtn = document.getElementById('meSave');
  const newSaveBtn = saveBtn.cloneNode(true);
  saveBtn.parentNode.replaceChild(newSaveBtn, saveBtn);
  newSaveBtn.id = 'meSave';
  newSaveBtn.onclick = () => {
    const vals = {};
    body.querySelectorAll('input').forEach(inp => {
      vals[inp.dataset.key] = inp.type === 'number' ? parseFloat(inp.value) || 0 : inp.value;
    });
    onSave(vals);
    clMdl('mdlEdit');
  };

  mdl.classList.add('active');
}

// ============================================================
// CUSTOM CONFIRM MODAL — zamena za browser confirm()
// ============================================================
export function showConfirm(message, onConfirm) {
  const mdl = document.getElementById('mdlEdit');
  document.getElementById('meTitle').textContent = 'Potvrda';
  const body = document.getElementById('meBody');
  body.textContent = '';
  const msg = document.createElement('p');
  msg.style.cssText = 'font-size:14px;color:var(--tx2);margin-bottom:8px;line-height:1.5';
  msg.textContent = message;
  body.appendChild(msg);

  const saveBtn = document.getElementById('meSave');
  const newSave = saveBtn.cloneNode(true);
  saveBtn.parentNode.replaceChild(newSave, saveBtn);
  newSave.id = 'meSave';
  newSave.textContent = 'Potvrdi';
  newSave.style.background = 'var(--dng)';
  newSave.onclick = () => { clMdl('mdlEdit'); newSave.style.background = ''; onConfirm(); };
  mdl.classList.add('active');
}

// ============================================================
// HAMBURGER MENU TOGGLE
// ============================================================
export function toggleSidebar() {
  const sidebar = document.getElementById('sidebar');
  sidebar.classList.toggle('mobile-open');
}

export function initParticles() {
  const pb = document.getElementById('ptcBox');
  for (let i = 0; i < 48; i++) {
    const p = document.createElement('div');
    p.className = 'ptc';
    p.style.left = Math.random() * 100 + '%';
    p.style.animationDuration = (6 + Math.random() * 9) + 's';
    p.style.animationDelay = (Math.random() * 1) + 's';
    const sz = 2.5 + Math.random() * 4;
    p.style.width = sz + 'px';
    p.style.height = sz + 'px';
    p.style.background = ['#c9a84c', '#e0c872', '#d4af37', '#b8962e'][Math.floor(Math.random() * 4)];
    p.style.boxShadow = '0 0 ' + (3 + Math.random() * 4) + 'px currentColor';
    pb.appendChild(p);
  }
  const eb = document.getElementById('emberBox');
  for (let i = 0; i < 60; i++) {
    const e = document.createElement('div');
    e.className = 'ember';
    const s = 3 + Math.random() * 7;
    e.style.width = s + 'px';
    e.style.height = (s * 2.2) + 'px';
    e.style.borderRadius = '50% 50% 50% 50% / 60% 60% 40% 40%';
    e.style.left = (3 + Math.random() * 94) + '%';
    e.style.bottom = '-3%';
    e.style.setProperty('--drift', (Math.random() * 60 - 30) + 'px');
    e.style.animationDuration = (2.5 + Math.random() * 4) + 's';
    e.style.animationDelay = (Math.random() * 1) + 's';
    const colors = ['#ff6b35', '#ff8c42', '#ffaa5c', '#ffd866', '#ff5c6a', '#ff4500', '#ff7043', '#e65100', '#ff3d00', '#ffab00'];
    const c = colors[Math.floor(Math.random() * colors.length)];
    e.style.background = 'linear-gradient(to top,' + c + ',rgba(255,200,50,.3))';
    e.style.boxShadow = '0 0 ' + (3 + Math.random() * 6) + 'px ' + c;
    eb.appendChild(e);
  }
}
